import { DropdownIndicatorProps, components } from 'react-select';

import { Icon } from 'components/Icon';

import { OptionType } from './Select.types';

export function DropdownIndicator(props: DropdownIndicatorProps<OptionType>) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.DropdownIndicator {...props}>
      <Icon name="chevron-down" size={16} />
    </components.DropdownIndicator>
  );
}
